// extracted by mini-css-extract-plugin
module.exports = {"moveRight":"Mapping_moveRight_2qzX-","moveLeft":"Mapping_moveLeft_3Gd_W","dataTableCon":"Mapping_dataTableCon_1vReY","headingBold":"Mapping_headingBold_25Kn_"};